import React from "react";
import { Helmet } from "react-helmet";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faScaleBalanced,
} from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import HeroSlider from "../components/HeroSlider";
import {useTranslation} from 'react-i18next';

const Services = () => {
  const {t} = useTranslation();
  return (
    <>
      <div className="avocatura">
        <Helmet>
          <title>
            Services | Min & Ying Legal Services Professional Corporation
          </title>
          
          <meta
            name="description"
            content="Services | Min & Ying Legal Services Professional Corporation"
          />
        </Helmet>

        <HeroSlider/>
        {/* <div className="container-fluid">
          <div className="row">
            <div className="hero-section">
              <div className="hero-overlay"></div>
              <div className="text-container d-flex flex-column justify-content-start align-items-start pt-6 slide">
                <div className="text-1 fs-2 pb-3">Min & Ying Legal Services Professional Corporation Professional Corporation</div>
                <div className="text-2 fs-4">
                  BIROU DE AVOCAT SI INSOLVENTA
                  <span className="fw-bold">
                    <br></br> Bucuresti{" "}
                  </span>
                </div>
                <div className="text-3 fst-italic fw-light">
                  "Nu este o adevărată justiție acolo unde nu există dreptate,
                  iar dreptatea nu poate fi găsită acolo unde nu există adevăr."
                  - <span>Lucius Annaeus Seneca.</span>
                </div>
              </div>
            </div>
          </div>
        </div> */}

        <div class="py-5 px-3 container" style={{maxWidth: '1500px', margin: 'auto'}}>
          {/* <h6 className="guide-text mb-4">NOTARY/COMMISSIONER SERVICES</h6>
          <p className="fw-normal">
            We provide reliable and efficient notary services to meet your legal needs. Whether you need documents notarized for personal, business, or international purposes, our certified notary professionals ensure accuracy and compliance with all legal requirements.
          </p> */}
          <h3 className="lh-base text-center guide-text-no-border font-weight-bold">
            {t('services.title')}
          </h3>

          <div className="row g-5 px-5 mobile-padding pt-4 ">
            <div className="col-lg-4 col-md-6 col-sm-12">
            <Link to="/services/ticket" class="text-decoration-none">
                <div className="card h-100">
                  <div class="ticket card-img-top">
                    <div class="overlay"></div>
                  </div>
                  <div className="card-body text-center text-white py-4">
                    <div class="d-flex gap-3 align-items-center px-3">
                      <FontAwesomeIcon
                        icon={faScaleBalanced}
                        size="2x"
                        className="law-icon pb-3"
                      />
                      <h5 className="card-title pb-2">{t('services.ticket')}</h5 >
                    </div>
                    <p className="card-text mx-1 px-3" style={{ textAlign: 'justify' }}>
                      {t('services.ticketIntro')}
                    </p>
                  </div>
                </div>
              </Link>
            </div>
            <div className="col-lg-4 col-md-6 col-sm-12">
              <Link to="/services/notary" class="text-decoration-none">
                <div className="card h-100">
                  <div class="notary card-img-top">
                    <div class="overlay"></div>
                  </div>
                  <div className="card-body text-center text-white py-4">
                    <div class="d-flex gap-3 align-items-center px-3">
                      <FontAwesomeIcon
                        icon={faScaleBalanced}
                        size="2x"
                        className="law-icon pb-3"
                      />
                      <h5 className="card-title pb-2">{t('services.notary')}</h5 >
                    </div>
                    <p className="card-text mx-1 px-3" style={{ textAlign: 'justify' }}>
                      {t('services.notaryIntro')}
                    </p>
                  </div>
                </div>
              </Link>
            </div>
            <div className="col-lg-4 col-md-6 col-sm-12">
              <Link to="/services/drafting" class="text-decoration-none">
                <div className="card h-100">
                  <div class="drafting card-img-top">
                    <div class="overlay"></div>
                  </div>
                  <div className="card-body text-center text-white py-4">
                    <div class="d-flex gap-3 align-items-center px-3">
                      <FontAwesomeIcon
                        icon={faScaleBalanced}
                        size="2x"
                        className="law-icon pb-3"
                      />
                      <h5 className="card-title pb-2">{t('services.drafting')}</h5 >
                    </div>
                    <p className="card-text mx-1 px-3" style={{ textAlign: 'justify' }}>
                      {t('services.draftingIntro')}
                    </p>
                  </div>
                </div>
              </Link>
            </div>
            <div className="col-lg-4 col-md-6 col-sm-12">
              <Link to="/services/pardon" class="text-decoration-none">
                <div className="card h-100">
                  <div class="pardon card-img-top">
                    <div class="overlay"></div>
                  </div>
                  <div className="card-body text-center text-white py-4">
                    <div class="d-flex gap-3 align-items-center px-3">
                      <FontAwesomeIcon
                        icon={faScaleBalanced}
                        size="2x"
                        className="law-icon pb-3"
                      />
                      <h5 className="card-title pb-2">{t('services.pardon')}</h5 >
                    </div>
                    <p className="card-text mx-1 px-3" style={{ textAlign: 'justify' }}>
                      {t('services.pardonIntro')}
                    </p>
                  </div>
                </div>
              </Link>
            </div>
            <div className="col-lg-4 col-md-6 col-sm-12">
              <Link to="/services/small-claim-court" class="text-decoration-none">
                <div className="card h-100">
                  <div class="small-claim card-img-top">
                    <div class="overlay"></div>
                  </div>
                  <div className="card-body text-center text-white py-4">
                    <div class="d-flex gap-3 align-items-center px-3">
                      <FontAwesomeIcon
                        icon={faScaleBalanced}
                        size="2x"
                        className="law-icon pb-3"
                      />
                      <h5 className="card-title pb-2">{t('smallClaimCourt.title')}</h5 >
                    </div>
                    <p className="card-text mx-1 px-3" style={{ textAlign: 'justify' }}>
                      {t('smallClaimCourt.intro')}
                    </p>
                  </div>
                </div>
              </Link>
            </div>
            <div className="col-lg-4 col-md-6 col-sm-12">
              <Link to="/services/landlord-tenant-dispute" class="text-decoration-none">
                <div className="card h-100">
                  <div class="landlord-tenant-dispute card-img-top">
                    <div class="overlay"></div>
                  </div>
                  <div className="card-body text-center text-white py-4">
                    <div class="d-flex gap-3 align-items-center px-3">
                      <FontAwesomeIcon
                        icon={faScaleBalanced}
                        size="2x"
                        className="law-icon pb-3"
                      />
                      <h5 className="card-title pb-2">{t('landlordTenantDispute.title')}</h5 >
                    </div>
                    <p className="card-text mx-1 px-3" style={{ textAlign: 'justify' }}>
                      {t('landlordTenantDispute.intro')}
                    </p>
                  </div>
                </div>
              </Link>
            </div>
            <div className="col-lg-4 col-md-6 col-sm-12">
              <Link to="/services/family-legal-services" class="text-decoration-none">
                <div className="card h-100">
                  <div class="family card-img-top">
                    <div class="overlay"></div>
                  </div>
                  <div className="card-body text-center text-white py-4">
                    <div class="d-flex gap-3 align-items-center px-3">
                      <FontAwesomeIcon
                        icon={faScaleBalanced}
                        size="2x"
                        className="law-icon pb-3"
                      />
                      <h5 className="card-title pb-2">{t('services.familyLegalServices')}</h5 >
                    </div>
                    <p className="card-text mx-1 px-3" style={{ textAlign: 'justify' }}>
                      {t('services.familyLegalServicesIntro')}
                    </p>
                  </div>
                </div>
              </Link>
            </div>
          </div>
          
          <div className="container py-4 ">
            <p className="more-services py-4">
            
            </p>
          </div>
        </div>
      </div>
    </>
  );
};
export default Services;
